import { useRegionData } from 'approot/shared/region/region.apollo';
import useUserData from 'approot/shared/user/user-data';
import {
  RegionDropdown,
  RegionLabel,
} from 'approot/shared/region/region-dropdown';
import { FlexCentreAlign } from 'approot/shared/styles/flex.style';

const FooterRegions = () => {
  const { isSignedIn } = useUserData();
  const { region } = useRegionData();

  return (
    <FlexCentreAlign>
      {isSignedIn ? (
        <RegionLabel region={region} />
      ) : (
        <RegionDropdown noBorder />
      )}
    </FlexCentreAlign>
  );
};

export default FooterRegions;
